import { useQuery, gql, useReactiveVar } from '@apollo/client';
import { appLanguage } from "../reactive-variables";

const GET_VACANCY_ONE = gql`
    query GetVacancyOne($vacancy_id_or_slug_eq: String!) {
        vacancy_one(where: { vacancy_id_or_slug_eq: $vacancy_id_or_slug_eq}) {
            id
            title
            description
            image_url
            salary
            created_at
            slug
            cvIsRequired
        }
    }
`

export const useVacancyOne = (vacancySlug) => {
    const language = useReactiveVar(appLanguage)

    const { data, loading, fetchMore } = useQuery(GET_VACANCY_ONE, {
        variables: { vacancy_id_or_slug_eq: vacancySlug },
        context: {
            headers: {
                "accept-language": language
            }
        }
    });

    return { data: data?.vacancy_one, loading, fetchMore }
};
